<script>
import DatePicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import moment from "@/utils/moment";

export default {
  props: {
    title: {
      type: [String, Boolean],
      required: false,
      default: false
    },
    day: {
      type: [Date, String],
      required: false
    },
    enabledDates: {
      type: Array,
      required: false
    },
    fromDate: {
      type: Date,
      required: false,
      default: false
    },
    toDate: {
      type: Date,
      required: false,
      default: false
    }
  },

  data() {
    return {
      ptBR,
      disabledDates: {}
    };
  },

  methods: {
    daySelected(day) {
      this.$emit("daySelected", day);
    },

    generateDisabledDates() {
      let dates = !this.enabledDates ? [] : this.pickDisabledDates();

      this.disabledDates = {
        from: this.fromDate,
        to: this.toDate,
        dates
      };
    },

    pickDisabledDates() {
      var dates = this.pickDatesBetween(this.toDate, this.fromDate);
      var enabledDates = this.enabledDates;

      dates = this.formatDates(dates);
      enabledDates = this.formatDates(enabledDates);

      dates = dates.filter(e => {
        return enabledDates.indexOf(e) === -1;
      });

      return this.formatDates(dates, true);
    },

    formatDates(dates, toDate = false) {
      return dates.map(e => {
        return toDate ? moment(e).toDate() : moment(e).format("Y-MM-DD");
      });
    },

    pickDatesBetween(startDate, endDate) {
      var dates = [],
        currentDate = startDate;

      while (currentDate <= endDate) {
        dates.push(currentDate);
        currentDate = moment(currentDate)
          .add(1, "days")
          .toDate();
      }

      return dates;
    }
  },

  mounted() {
    this.generateDisabledDates();
  },

  components: {
    DatePicker
  }
};
</script>

<template>
  <div class="section mb-0">
    <div v-if="title" class="section-title">
      {{ title }}
      <hr />
    </div>

    <date-picker
      :value="day"
      :disabledDates="disabledDates"
      :full-month-name="true"
      :maximumView="'day'"
      :language="ptBR"
      :format="'dd MMMM yyyy'"
      placeholder="selecione um dia"
      @selected="daySelected"
    />
  </div>
</template>



// WEBPACK FOOTER //
// src/components/_Shared/DatePicker.vue